/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Opening_LabelInputs */

const en_explorer_info_opening_label = /** @type {(inputs: Explorer_Info_Opening_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const fr_explorer_info_opening_label = /** @type {(inputs: Explorer_Info_Opening_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouverture...`)
};

const de_explorer_info_opening_label = /** @type {(inputs: Explorer_Info_Opening_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnung...`)
};

const it_explorer_info_opening_label = /** @type {(inputs: Explorer_Info_Opening_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apertura...`)
};

const ru_explorer_info_opening_label = /** @type {(inputs: Explorer_Info_Opening_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытие...`)
};

const es_explorer_info_opening_label = /** @type {(inputs: Explorer_Info_Opening_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apertura...`)
};

const zh_cn2_explorer_info_opening_label = /** @type {(inputs: Explorer_Info_Opening_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开场……`)
};

const ja_explorer_info_opening_label = /** @type {(inputs: Explorer_Info_Opening_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オープニング...`)
};

const hi_explorer_info_opening_label = /** @type {(inputs: Explorer_Info_Opening_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उद्घाटन...`)
};

const pt_pt2_explorer_info_opening_label = /** @type {(inputs: Explorer_Info_Opening_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abertura...`)
};

/**
* | output |
* | --- |
* | "Opening..." |
*
* @param {Explorer_Info_Opening_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_opening_label = /** @type {((inputs?: Explorer_Info_Opening_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Opening_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_opening_label(inputs)
	if (locale === "de") return de_explorer_info_opening_label(inputs)
	if (locale === "it") return it_explorer_info_opening_label(inputs)
	if (locale === "ru") return ru_explorer_info_opening_label(inputs)
	if (locale === "es") return es_explorer_info_opening_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_opening_label(inputs)
	if (locale === "ja") return ja_explorer_info_opening_label(inputs)
	if (locale === "hi") return hi_explorer_info_opening_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_opening_label(inputs)
	return en_explorer_info_opening_label(inputs)
});